import { Typography } from '@mui/material';

export default function Stat({ stat }) {
	return (
		<Typography
			sx={{
				color: '#464646',
				fontFamily: 'Roboto',
				fontStyle: 'normal',
				fontWeight: '600',
				fontSize: '40px',
				lineHeight: '24px',
				letterSpacing: '0.15px',
			}}
		>
			{stat}
		</Typography>
	);
}
